import React, { useEffect, useState } from 'react';
import './Gallery.scss';
import Gallery from 'react-grid-gallery';
import ScrollContainer from 'react-indiana-drag-scroll'
import { getImageUrl } from '../../../utils/ImageUrl';

import { Row, Col } from 'react-bootstrap';
import EmptyHolder from '../../../Components/EmptyHolder/EmptyHolder';
import Loading from '../../../Components/Loading/Loading';
const ImgGallery = (props) => {
    const {data, loading} = props;
    const [IMAGES, setIMAGES] = useState([]);

    useEffect(() => {
        let tempImages = [];
        if (props.data && props.data.length > 0) {
            props.data.forEach((img) => {
                if (img && img.url && img.formats && img.formats.thumbnail) {
                    tempImages.push({ 
                        src: getImageUrl(img.url), 
                        thumbnail: getImageUrl(img.formats.thumbnail.url), 
                        thumbnailWidth: img.formats.thumbnail.width || 200, 
                        thumbnailHeight: img.formats.thumbnail.height || 200 
                    });
                }
            });
        }
        setIMAGES(tempImages);
    }, [props.data])

    return (
        <Row className="m-0 mb-3">
            <Col>
                {loading && <Loading />}
                {!loading && (!data || data.length === 0) &&
                    <Col lg={12} className="d-flex justify-content-center">
                        <EmptyHolder text="Images Not Found" />
                    </Col>
                }
                {!loading && IMAGES.length > 0 && (
                    <ScrollContainer
                        hideScrollbars={false}
                    >
                        <Gallery images={IMAGES} enableImageSelection={false} />
                    </ScrollContainer>
                )}
            </Col>
        </Row>
    )
}

export default ImgGallery;